var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "container" } },
    [
      _c("p", [_vm._v(_vm._s(_vm.placeholder))]),
      _c(
        "el-date-picker",
        {
          staticClass: "width",
          attrs: {
            type: "daterange",
            "start-placeholder": "Data Inicial",
            "end-placeholder": "Data Final",
            "unlink-panels": "unlink-panels",
            format: "dd/MM/yyyy",
            "picker-options": _vm.pickerOptions
          },
          model: {
            value: _vm.value,
            callback: function($$v) {
              _vm.value = $$v
            },
            expression: "value"
          }
        },
        [
          _c(
            "span",
            { attrs: { slot: "range-separator" }, slot: "range-separator" },
            [_vm._v("até")]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0d59b335", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d59b335","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/relatorios_ouvidoria/components/InputEntreDatas.vue
// module id = null
// module chunks = 